import { render } from "./MaterialProgress.vue?vue&type=template&id=387cd8ad"
import script from "./MaterialProgress.vue?vue&type=script&lang=js"
export * from "./MaterialProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__